import styled from '@emotion/styled';

export const Container = styled.ul`
  display: flex;
  justify-content: center;
  gap: 18px;
  height: 62px;
  width: max-content;
  /* 
  @media screen and (min-width: 1440px) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    margin: 0 auto;
  } */
`;

export const ControllerList = styled.li`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 2px;
`;

export const ControllerText = styled.span`
  font-size: 11px;
  color: #777777;
  transition: all 0.3s ease;
`;

export const ControllerButton = styled.a`
  width: 45px;
  height: 45px;
  border: 0;
  background: #1f1f1f no-repeat center center;
  border-radius: 100%;

  &:hover {
    fill: #eee;
  }
`;
